import React from "react";
import Modal from "components/UI/DialogModal";
import { CircularProgress, Grid, Stack } from "@mui/material";
import MuiButton from "components/UI/MuiButton";
import { useTranslation } from "react-i18next";
import { ICompanyJob } from "models/companyJob";
import { ICompanyDepartments } from "models/companyDepartment";
import { InputTypes } from "constants/enums";
import { IFormField } from "models/app";
import Form from "components/UI/Form";

interface Props {
  open: boolean;
  companyJob: ICompanyJob;
  loading: boolean;
  Departments: ICompanyDepartments[];
  onChanges: (name: string, value: any) => void;
  onClose: () => void;
  onSubmit: () => void;
}

const EditCompanyJob: React.FC<Props> = ({
  open,
  loading,
  Departments,
  onClose,
  onSubmit,
  onChanges,
  companyJob,
}) => {
  const { t } = useTranslation();

  const departmentsOptions = Departments.map((department) => ({
    value: department.id,
    label: department.name,
  }));

  let basicFields: IFormField[] = [
    {
      name: "companyDepartmentId",
      label: "Enter Department",
      type: InputTypes.SELECT,

      defaultValue: departmentsOptions.find(
        (c) => c.value === companyJob.companyDepartmentId
      ),
      options: departmentsOptions,
      multiple: false,
      internalLabel: true,
      required: true,
    },
    {
      name: "name",
      label: t("T_name"),
      type: InputTypes.TEXT,
      defaultValue: companyJob.name,
      internalLabel: true,
      required: true,
    },
    {
      name: "nameAr",
      label: t("T_name_Ar"),
      type: InputTypes.TEXT,
      defaultValue: companyJob.nameAr,
      internalLabel: true,
      required: true,
    },
  ];

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        title={t("T_edit_job")}
        maxWidth="lg"
        children={
          <Stack spacing={2} p={2}>
            <Form fields={basicFields} onChange={onChanges} />
          </Stack>
        }
        actions={
          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
            px={1}
          >
            <MuiButton
              variant="contained"
              sx={{ bgcolor: "warning.main", color: "white" }}
              size="large"
              onClick={onClose}
            >
              {t("T_cancel")}
            </MuiButton>
            <MuiButton
              variant="contained"
              sx={{ bgcolor: "primary.main", color: "white" }}
              disabled={loading}
              size="large"
              onClick={onSubmit}
            >
              {t("T_add")}
              <CircularProgress
                size={10}
                sx={{ mx: 2, display: loading ? "" : "none" }}
              />
            </MuiButton>
          </Grid>
        }
      />
    </>
  );
};

export default EditCompanyJob;
